import { render, staticRenderFns } from "./CreateAssessmentHeader.vue?vue&type=template&id=b895c896&scoped=true"
import script from "./CreateAssessmentHeader.vue?vue&type=script&lang=ts"
export * from "./CreateAssessmentHeader.vue?vue&type=script&lang=ts"
import style0 from "./CreateAssessmentHeader.vue?vue&type=style&index=0&id=b895c896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b895c896",
  null
  
)

export default component.exports